'use client';

import { Flex, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';

export default function ReturnNotice() {
  const { t } = useTranslation('webshop.orderBlock.digitalProduct');

  return (
    <Flex direction='column'>
      <Typography fontWeight='bold' mb={0}>
        {t('returnTitle')}
      </Typography>
      <Typography>{t('returnText')}</Typography>
    </Flex>
  );
}
